import { createStore, applyMiddleware, compose } from "redux";
import CombineReducers from "./reducers";
import ReduxThunk from "redux-thunk";
import PaymentReducer from "./payment"; // no changes here 😀

const composeEnhancers =
	(typeof window !== "undefined" &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
	compose;

const store = createStore(
	CombineReducers,
	composeEnhancers(applyMiddleware(ReduxThunk)),
);

export default store;
